export const createDataTable = function(data,searchColumnArray=null,orderByArray=null,pageCurrent=0,pageCount=25){
  if(searchColumnArray!=null){
    data=this.$searchColumnArray(data,searchColumnArray);
  }

  if(orderByArray!=null && orderByArray.column!=""){
    data=this.$orderByArray(data,orderByArray.column,orderByArray.desc,orderByArray.isNumber,orderByArray.isDate);
  }

  //------------------------

  var pageLength=[];
  for (let index = 0; index < Math.ceil(data.length/parseInt(pageCount)); index++) {
    pageLength.push(index);
  }
  if(Math.ceil(data.length/parseInt(pageCount))<=parseInt(pageCurrent)){
    pageCurrent=pageLength[pageLength.length-1];
  }
  if(parseInt(pageCurrent)<0){
    pageCurrent=0;
  }
  var pageData=[];
  pageData=data.slice(parseInt(pageCurrent)*parseInt(pageCount),parseInt(pageCurrent)*parseInt(pageCount)+parseInt(pageCount));
  var pagerList=[];
  if(pageCurrent<4){
    for (let index = 0; index < pageLength.length; index++) {
      if(index<7){
        pagerList.push(index);
      }
    }
  } else if(pageCurrent>pageLength.length-5){
    for (let index = 0; index < pageLength.length; index++) {
      if(index>(pageLength.length-8)){
        pagerList.push(index);
      }
    }
  }else{
    pagerList.push(pageLength[0]);
    for (let index = 0; index < pageLength.length; index++) {
      if(index>pageCurrent-3 && index<pageCurrent+3){
        pagerList.push(index);
      }
    }
    pagerList.push(pageLength[pageLength.length-1]);
  }
  if(pageCurrent==undefined){
    pagerList=[];
  }
  let info=data.length+" kayıttan "+(parseInt(pageCount)*parseInt(pageCurrent)+1)+" ile "+((parseInt(pageCount)*parseInt(pageCurrent)+parseInt(pageCount))>data.length?data.length:(parseInt(pageCount)*parseInt(pageCurrent)+parseInt(pageCount)))+" kayıtları görüyorsunuz.";
  if(pageCurrent==undefined){
    info="";
  }
  return {
    page:{
      current:pageCurrent,
      length:pagerList,
      info:info,
      totalPage:Math.ceil(data.length/pageCount)
    },
    data:pageData
  }
}